exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.thumbnail-icon[data-v-fc29ee4e] {\r\n    max-width: 40px;\r\n    max-height: 40px;\n}\r\n", ""]);

// exports
